import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FormControl, FormGroup} from "@angular/forms";
import {FS3Notification} from "../../../objects/notification";

@Component({
  selector: 'app-send-message-popup',
  templateUrl: './send-message-popup.component.html',
  styleUrls: ['./send-message-popup.component.css']
})
export class SendMessagePopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<object>();

  public componentForm: FormGroup = new FormGroup({});
  state: string = 'default';
  constructor() { }

  ngOnInit(): void {
    const message = this.payload['old_message'] ? this.payload['old_message'] : '';
    if(this.payload['popup_state']) this.state = this.payload['popup_state'];  //default/comment etc
    const messageControl = new FormControl();
    messageControl.setValue(message)
    this.componentForm.addControl('messageControl', messageControl);
  }

  public sendAndClose(): void {
    const message = this.componentForm.get('messageControl').value;
    if(message) this.success.emit({message: message})
  }
  public onNoClick(): void {
    this.close.emit()
  }

}
